import { createFeature } from '@ngrx/store';

import { felReducer } from './fel.reducer';

export const felFeature = createFeature({
  name: 'fel',
  reducer: felReducer,
});
